
import Loading from 'vux/src/components/loading/index.vue'

import { mapState } from "vuex";
import * as myCode from "@js/public/code";
import { setSStore, getSStore, IsValid, hashQuery, getRoutePage, setRoutePage} from "@js/public/mUtils";
import Loading2 from "@/components/publicComponents/loading";
import sLoading from "@/components/publicComponents/sLoading";
import {wxProAd} from "@/mixins/wxProAd";
export default {
name: "App",
mixins: [wxProAd],
components: {
Loading,
"my-loading": Loading2,
"my-sloading": sLoading
},
provide() {
return {
reload: this.reload
};
},
data() {
return {
sMacAddr: ""
};
},
computed: {
mapState: function() {
return this.$store.state.isLoading;
},
loadState: function() {
return this.$store.state.allSLoading;
}
/* ...mapState({
isLoading: state => state.vux.isLoading
}) */
},
created() {},
mounted() {
if (hashQuery("source") === "yx") {
setSStore("source", hashQuery("source"));
setSStore("url", hashQuery("url"));
} else {
setSStore("source", "wx");
}
if (IsValid(getSStore("token"))) {

this.$store.dispatch("saveLogined", true);
}
},
methods: {
reload() {
this.$route.meta.keepAlive = false;
this.$nextTick(function() {
this.$route.meta.keepAlive = true;
});
},
/* 自动登录 */



















}
};



// WEBPACK FOOTER //
// ./src/App.vue